<template>
	<v-container fluid class="fill-height pa-0 py-0 px-0">
		<v-layout row wrap>
			<v-flex xs12 md12>
				<section>
					<v-container class="fill-height px-4 py-12">
						<v-main
							class="d-flex align-center mx-auto"
							style="height: 100%; width: 100%; max-width: 600px"
						>
							<div class="text-center">
								<p
									class="
										white--text
										font-weight-bold
										display-1
									"
								>
									Welcome to Thalias
								</p>
								<p class="secondary--text">
									Create your account
								</p>
							</div>
							<v-stepper v-model="stepper">
								<v-stepper-header>
									<v-stepper-step
										:complete="stepper > 1"
										step="1"
										color="#c09949"
									>
										{{ $t("label.phone_number") }}
									</v-stepper-step>

									<v-divider></v-divider>

									<v-stepper-step
										:complete="stepper > 2"
										step="2"
										color="#c09949"
									>
										{{ $t("label.verify_otp") }}
									</v-stepper-step>
								</v-stepper-header>

								<v-stepper-items>
									<v-stepper-content step="1">
										<ValidationObserver
											ref="obs"
											v-slot="{ invalid }"
										>
											<v-form>
												<v-card
													flat
													class="mb-5"
													color="grey lighten-5"
													style="min-height: 200px"
												>
													<v-card-text>
														<v-layout
															row
															wrap
															class="text-center"
														>
															<v-flex xs12 md12>
																<v-avatar
																	size="100"
																	color="primary"
																>
																	<v-icon
																		size="70"
																		dark
																		>mdi-phone</v-icon
																	>
																</v-avatar>
															</v-flex>
															<v-flex
																xs12
																class="mt-10"
															>
																<ValidationProvider
																	rules="required|phone"
																	name="phone"
																	v-slot="{
																		errors,
																	}"
																>
																	<vue-tel-input-vuetify
																		v-model="
																			phone
																		"
																		mode="international"
																		:preferredCountries="[
																			'KH',
																		]"
																		filled
																		:placeholder="
																			null
																		"
																		:label="
																			$t(
																				'label.enter_a_phone_number'
																			)
																		"
																		validate-on-blur
																		required
																		v-mask="
																			'###-###-####'
																		"
																		:error-messages="
																			errors
																		"
																	></vue-tel-input-vuetify>
																</ValidationProvider>
															</v-flex>
															<v-flex xs12>
																<div
																	id="recaptcha-container"
																></div>
															</v-flex>
														</v-layout>
													</v-card-text>
													<v-card-actions>
														<v-spacer></v-spacer>
														<v-btn
															type="submit"
															color="secondary"
															@click.prevent="
																submit()
															"
															rounded
															:disabled="invalid"
															id="sign-in-button"
															:loading="
																$wait.is(
																	'submitting'
																)
															"
														>
															{{
																$t(
																	"label.send_otp"
																)
															}}
														</v-btn>
													</v-card-actions>
												</v-card>
											</v-form>
										</ValidationObserver>
									</v-stepper-content>

									<v-stepper-content step="2">
										<ValidationObserver
											ref="obs"
											v-slot="{ invalid }"
										>
											<v-card
												flat
												class="mb-5"
												color="grey lighten-5"
												style="min-height: 200px"
											>
												<v-card-text>
													<v-layout
														wrap
														row
														class="text-center"
													>
														<v-flex xs12 md12>
															<v-avatar
																size="100"
																color="primary"
															>
																<v-icon
																	size="70"
																	dark
																	>mdi-lock</v-icon
																>
															</v-avatar>
														</v-flex>
														<v-flex
															xs12
															class="my-10"
															text-center
														>
															<ValidationProvider
																rules="required"
																name="otp"
																v-slot="{
																	errors,
																}"
															>
																<v-otp-input
																	v-model="
																		otp
																	"
																	ref="otpInput"
																	input-classes="otp-input"
																	separator="-"
																	:num-inputs="
																		6
																	"
																	:should-auto-focus="
																		true
																	"
																	:is-input-num="
																		true
																	"
																	style="
																		margin: auto !important;
																		justify-content: center;
																	"
																	@on-complete="
																		handleOnComplete
																	"
																	:error-messages="
																		errors
																	"
																/>
															</ValidationProvider>
														</v-flex>
													</v-layout>
												</v-card-text>
												<v-card-actions>
													<v-btn
														text
														@click="stepper = 1"
														rounded
													>
														<v-icon left
															>mdi-keyboard-backspace</v-icon
														>
														{{ $t("Back") }}
													</v-btn>
													<v-spacer></v-spacer>
													<v-btn
														color="secondary"
														rounded
														@click="verify()"
														:loading="
															$wait.is(
																'verifying'
															)
														"
														:disabled="invalid"
													>
														{{ $t("label.verify") }}
													</v-btn>
												</v-card-actions>
											</v-card>
										</ValidationObserver>
									</v-stepper-content>
								</v-stepper-items>
							</v-stepper>
						</v-main>
					</v-container>
				</section>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import {
	getAuth,
	RecaptchaVerifier,
	signInWithPhoneNumber,
} from "firebase/auth";
import { VueMaskDirective } from "v-mask";
export default {
	directives: {
		mask: VueMaskDirective,
	},
	data() {
		return {
			background: this.$page.props.assets.login_background,
			stepper: 1,
			phone: null,
			otp: null,
			length: 6,
			appVerifier: "",
			confirmationResult: null,
		};
	},

	computed: {
		minHeight() {
			const height = this.$vuetify.breakpoint.mdAndUp ? "100vh" : "50vh";

			return `calc(${height} - ${this.$vuetify.application.top}px)`;
		},
	},

	methods: {
		async submit() {
			try {
				this.$wait.start("submitting");
				const auth = getAuth();
				const confirmationResult = await signInWithPhoneNumber(
					auth,
					this.phone,
					this.appVerifier
				);

				if (confirmationResult) {
					this.confirmationResult = confirmationResult;
					this.stepper = 2;
				}
			} catch (error) {
				alert(error.code);
			} finally {
				this.$wait.end("submitting");
			}
		},

		async verify() {
			try {
				this.$wait.start("verifying");

				const result = await this.confirmationResult.confirm(this.otp);
				if (result) {
					this.$inertia.post(this.$route("auth.firebase"), {
						firebase_token: result.user.accessToken,
					});
				}
			} catch (error) {
				alert(error.code);
			} finally {
				this.$wait.end("verifying");
			}
		},

		handleOnComplete(value) {
			this.otp = value;
		},
	},

	mounted() {
		const auth = getAuth();
		this.appVerifier = new RecaptchaVerifier(
			"recaptcha-container",
			{
				size: "invisible",
				callback: (response) => {},
				"expired-callback": () => {},
			},
			auth
		);
	},
};
</script>

<style >
.otp-input {
	width: 40px;
	height: 40px;
	padding: 5px;
	margin: 0 10px;
	font-size: 20px;
	border-radius: 4px;
	border: 1px solid rgba(0, 0, 0, 0.3);
	text-align: center;
}
.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
	-webkit-appearance: none;
	margin: 0;
}
</style>